import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import logoImage from '../../assets/logo.png';
import defaultProfile from '../../assets/default.png'; // fallback image

const USERS_BASE_URL = import.meta.env.VITE_USERS_BASE_URL;

function Header({ questions }) {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) return;

      try {
        const response = await fetch(
          `${USERS_BASE_URL}/profile/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        
        if (!response.ok) {
          if (response.status === 401) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          window.location.href = "/login";
        }
          throw new Error('Failed to fetch profile');
        }
        
        const data = await response.json();
        setUser(data);
      } catch (error) {
        console.error("Failed to fetch profile:", error.message);
      }
    };

    fetchProfile();
  }, []);

  const handleProfileClick = () => {
    navigate('/dashboard/profile');
  };

  const handleHomeClick = () => {
    navigate('/dashboard');
  };

  const profileImageUrl = user?.image
    ? user.image.startsWith('http') ? user.image : `${USERS_BASE_URL}${user.image}`
    : defaultProfile;

  // Handle search filtering
  const handleSearch = () => {
    if (searchTerm.trim() === '') {
      alert('Please enter a search term.');
      return;
    }

    navigate(`/dashboard/search?query=${searchTerm}`);
  };

  return (
    <header className="header">
      <div className="header-left">
        <img
          src={logoImage}
          alt="Discussion Forum Logo"
          className="logo"
          onClick={handleHomeClick}
          style={{ cursor: 'pointer' }}
        />
        <span
          className="home-text"
          onClick={handleHomeClick}
          style={{ marginLeft: '10px' }}
        >
          Home
        </span>
      </div>

      {/* Search Bar */}
      <div className="header-center">
        <input
          type="text"
          placeholder="Search questions or tags..."
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button className="search-button" onClick={handleSearch}>
          Search
        </button>
      </div>

      <div className="header-right">
        <div
          className="profile-container"
          onClick={handleProfileClick}
        >
          <img
            src={profileImageUrl}
            alt="User Profile"
            className="profile-icon"
          />
          {user?.first_name && <span className="profile-name">{user.first_name}</span>}
        </div>
      </div>
    </header>
  );
}

export default Header;